import Component from 'gia/Component';

import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';


export default class LogosMarquee extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      swiper: {}
    };
  }

  mount() {
    let that = this;
    const swiper = new Swiper(this.ref.swiper, {
      modules: [Autoplay],
      speed: 6000,
      spaceBetween: 50,
      slidesPerView: 6,
      loop: true,
      allowTouchMove: false,

      autoplay: {
        delay: 1,
        disableOnInteraction: false
      },
      breakpoints: {
        1280: {
          slidesPerView: 7,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 5,
        },
        640: {
          slidesPerView: 5
        },
        320: {
          slidesPerView: 5,
          spaceBetween: 15
        }
      }
    });
  }


}